import { motion } from 'framer-motion';
import styled from 'styled-components';
import { color } from '../../styles/mixins';

export const SheetContainer = styled(motion.div)`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  height: 100;
  padding: 0 40px;
  background-color: ${color('white')};
  z-index: 99;
  overflow: scroll;
`;
